<div class="card" id="kba_card">
    <div class="card-body" id="kba_card_body">
     <div id="knowledgebase_detail_title" class="detail-title-font" [innerHTML]="knowledgebaseDetail.kbaBasicInfo.title"> </div>
        <div id="knowledgebase_info">
            <ul class="kba-attr-list pl-0">
                <li><span class="kba-attr-label" id="kba_classification">{{ 'KnowledgeBaseDetail.classification' |  translate | uppercase}}
                    </span> &nbsp;
                    <span class="kba-attr-value">{{knowledgebaseDetail.kbaBasicInfo.classification.classificationName}}</span>
                </li>
                <li><span class="kba-attr-label" id="kba_created">{{ 'KnowledgeBaseDetail.createdDate' | translate | uppercase}}
                    </span>&nbsp;
                    <span class="kba-attr-value">{{knowledgebaseDetail.kbaBasicInfo.createdDate}}</span>
                </li>
                <li><span class="kba-attr-label" id="kba_modified">{{ 'KnowledgeBaseDetail.updatedDate' | translate | uppercase }}
                    </span>&nbsp;
                    <span class="kba-attr-value">{{knowledgebaseDetail.updatedDate}}</span>
                </li>
                <li><span class="kba-avg-rating" id="rateAvg"></span>({{knowledgebaseDetail.voteCount}})</li>
                <li><span class="kba-attr-label"><em class="fa fa-eye"></em>&nbsp; {{knowledgebaseDetail.kbaBasicInfo.viewCount}}</span></li>
                <li><span><em [ngClass]="knowledgebaseDetail.hasAttachment ? 'viewAttachment': 'hasAttachment'"  (click)="getAttachment()" data-toggle="modal" 
                    data-target="#kba_attachment" class="fa fa-paperclip"></em></span></li>
            </ul>
            <ul class="kba-attr-list pl-0">
                <li *ngIf="isItemTypes"><span class="kba-attr-label" id="kba_itemtype">{{ 'KnowledgeBaseDetail.itemType' | translate | uppercase }}</span>&nbsp;
                    <span class="kba-attr-value">{{knowledgebaseDetail.itemType}}</span>
                </li>
                <li *ngIf="isItems"><span class="kba-attr-label" id="kba_item">{{ 'KnowledgeBaseDetail.item' | translate | uppercase }} </span>&nbsp;
                    <span class="kba-attr-value">{{knowledgebaseDetail.item}}</span>
                </li>
            </ul>
        </div>
        <!--Knowledgebase Detail Summary-->
        <div *ngIf="isArticle" class="mt-4">
            <div  class="mb-1" id="knowledgebase_summary_id">{{ 'KnowledgeBaseDetail.summary' | translate | uppercase }}</div>
            <div class="knowledgebase-summary" [innerHTML]="knowledgebaseDetail.summary"></div>
        </div>
        <!--Knowledgebase Detail Description-->
        <div *ngIf="isArticle" class="mb-1 mt-4" id="knowledgebase_desc_id">{{ 'KnowledgeBaseDetail.description' | translate | uppercase }}</div>
        <div class="knowledgebase-detail-desc" [innerHTML]="knowledgebaseDetail.description"></div>

        <!--Rating-->
        <div class="mb-2 d-inline-flex">
                <span>{{'KnowledgeBaseDetail.rateKba' | translate}}</span>
                <span class="user-rating" id="rateUser"></span>
        </div>

        <div class="mt-4">
                <div class="knowledgebase-summary text-center pt-1">
                    <div> {{ 'ProposedSolutionDetail.resolvedrequestmessage' | translate }}</div>
                    <div class="text-center pt-3">
                        <button type="button" class="btn zsd-cust-filter-button" id="zsd_cust_button_create"
                                (click)=resolveRequest()> {{ 'ProposedSolutionDetail.resolvedrequest' | translate }}</button>
            
                            <button type="button" class="btn zsd-cust-filter-button" id="zsd_cust_button_cancel"
                                data-dismiss="modal" [routerLink]="['/requests']">
                                {{ 'ProposedSolutionDetail.gotorequests' | translate }} </button>
                        </div>
                </div>
        </div>
    </div>
</div>




<!--Attachment  Modal -->
<div class="modal" id="kba_attachment">
        <div class="modal-dialog modal-dialog-centered modal-md">
          <div class="modal-content" id="modal_content_override">                    
            <div class="modal-header" id="attachment-header">
                <div id="attachment_header_text">{{ 'KnowledgeBaseDetail.attachments' | translate }}</div>

              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>                       
            <div class="modal-body" id="modal_body_override"> 
                 <!-- Spinner -->
                 <zsd-spinner *ngIf="attachmentIsLoading" id="spinner" role="progressbar"
                 class="custom-spinner"></zsd-spinner>
                <div *ngFor="let attachment of kbaAttachmentResponse" class="attachment-detail">
                    <div class="attachment-name">
                   <a id="attachment_link_text" (click)="attachmentDetails(attachment)">{{attachment.attachmentName}}</a>
                   </div>
                   <div >
                       <span>{{attachment.attachmentSize}}</span>
                   </div>
                </div>      
            </div>                     
          </div>
        </div>
      </div>
<!-- End of attachment modal -->